import { render } from "./changeImageLinkModal.vue?vue&type=template&id=52c78cd8"
import script from "./changeImageLinkModal.vue?vue&type=script&lang=js"
export * from "./changeImageLinkModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/clients.printpigeons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__